"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconFolder = function SvgIconFolder(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "folder icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Folder Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40 13H21a1 1 0 01-.718-.306L17.6 9.918A3.012 3.012 0 0015.436 9H8.572A3.576 3.576 0 005 12.57v22.86A3.576 3.576 0 008.572 39h30.856A3.576 3.576 0 0043 35.43V16a3 3 0 00-3-3z"
  }));
};

var _default = SvgIconFolder;
exports.default = _default;